import { c as _c } from "react/compiler-runtime";
import { Download, TriangleAlert } from 'lucide-react';
import { useState } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useExportBackupFile } from '@/hooks/backup/use-export-backup-file';
import { usePianoProfileState } from '@/hooks/store/use-piano-profile-store';
import { useTranslation } from '@/hooks/use-translation';
export interface NewProfileDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (brand: string, model: string) => void;
}
export const NewProfileDialog = t0 => {
  const $ = _c(80);
  const {
    isOpen: open,
    onOpenChange,
    onConfirm
  } = t0;
  const {
    t
  } = useTranslation();
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const {
    isDemoProfile
  } = usePianoProfileState();
  const {
    exportBackupFile
  } = useExportBackupFile();
  let t1;
  if ($[0] !== brand || $[1] !== model || $[2] !== onConfirm || $[3] !== onOpenChange) {
    t1 = () => {
      onConfirm(brand, model);
      setBrand("");
      setModel("");
      onOpenChange(false);
    };
    $[0] = brand;
    $[1] = model;
    $[2] = onConfirm;
    $[3] = onOpenChange;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleConfirm = t1;
  let t2;
  if ($[5] !== onOpenChange) {
    t2 = () => {
      setBrand("");
      setModel("");
      onOpenChange(false);
    };
    $[5] = onOpenChange;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleCancel = t2;
  let t3;
  if ($[7] !== t) {
    t3 = t("File", {
      ns: "navigation"
    });
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("New Profile", {
      ns: "navigation"
    });
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <span className="ptl-label">{t3} ·{" "}{t4}</span>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("Create a new piano profile");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = <DialogTitle>{t6}</DialogTitle>;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <DialogHeader className="gap-2 pr-9">{t5}{t7}</DialogHeader>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t) {
    t9 = t("Piano brand");
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <Label htmlFor="brand">{t9}</Label>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = e => setBrand(e.target.value);
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t("Brand");
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== brand || $[29] !== t12) {
    t13 = <Input id="brand" value={brand} onChange={t11} placeholder={t12} />;
    $[28] = brand;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t10 || $[32] !== t13) {
    t14 = <div className="flex flex-col gap-[7px]">{t10}{t13}</div>;
    $[31] = t10;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t) {
    t15 = t("Piano model");
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15) {
    t16 = <Label htmlFor="model">{t15}</Label>;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = e_0 => setModel(e_0.target.value);
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t) {
    t18 = t("Model");
    $[39] = t;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== model || $[42] !== t18) {
    t19 = <Input id="model" value={model} onChange={t17} placeholder={t18} />;
    $[41] = model;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t16 || $[45] !== t19) {
    t20 = <div className="flex flex-col gap-[7px]">{t16}{t19}</div>;
    $[44] = t16;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== isDemoProfile || $[48] !== t) {
    t21 = isDemoProfile ? null : <Alert variant="warn"><TriangleAlert /><AlertDescription>{t("All data from the current profile will be deleted. Please save your work first!")}</AlertDescription></Alert>;
    $[47] = isDemoProfile;
    $[48] = t;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Download className="size-[15px]" />;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t) {
    t23 = t("Export the current profile");
    $[51] = t;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== exportBackupFile || $[54] !== t23) {
    t24 = <button type="button" onClick={exportBackupFile} className="inline-flex cursor-pointer items-center gap-1.5 self-start text-[14px] font-semibold text-ptl-brass transition-colors hover:text-foreground">{t22}{t23}</button>;
    $[53] = exportBackupFile;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t) {
    t25 = t("Cancel");
    $[56] = t;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== handleCancel || $[59] !== t25) {
    t26 = <Button variant="outlineStrong" onClick={handleCancel}>{t25}</Button>;
    $[58] = handleCancel;
    $[59] = t25;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t) {
    t27 = t("Create New Profile");
    $[61] = t;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== handleConfirm || $[64] !== t27) {
    t28 = <Button onClick={handleConfirm}>{t27}</Button>;
    $[63] = handleConfirm;
    $[64] = t27;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== t26 || $[67] !== t28) {
    t29 = <DialogFooter>{t26}{t28}</DialogFooter>;
    $[66] = t26;
    $[67] = t28;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] !== t14 || $[70] !== t20 || $[71] !== t21 || $[72] !== t24 || $[73] !== t29 || $[74] !== t8) {
    t30 = <DialogContent aria-describedby={undefined}>{t8}{t14}{t20}{t21}{t24}{t29}</DialogContent>;
    $[69] = t14;
    $[70] = t20;
    $[71] = t21;
    $[72] = t24;
    $[73] = t29;
    $[74] = t8;
    $[75] = t30;
  } else {
    t30 = $[75];
  }
  let t31;
  if ($[76] !== onOpenChange || $[77] !== open || $[78] !== t30) {
    t31 = <Dialog open={open} onOpenChange={onOpenChange}>{t30}</Dialog>;
    $[76] = onOpenChange;
    $[77] = open;
    $[78] = t30;
    $[79] = t31;
  } else {
    t31 = $[79];
  }
  return t31;
};